export type XPayStationWidget = {
    init: (options: XsollaWidgetOptions) => void,
    open: () => void,
    on: (events: XPayStationWidgetEvents, handler?: Function) => void,
    off: (events: XPayStationWidgetEvents, handler?: Function) => void
}


export enum XPayStationWidgetEvents {
    INIT = 'init',
    OPEN = 'open ',
    LOAD = 'load ',
    CLOSE = 'close ',
    STATUS = 'status ',
    STATUS_INVOICE = 'status-invoice',
    STATUS_DELIVERING = 'status-delivering',
    STATUS_DONE = 'status-done',
    STATUS_TROUBLED = 'status-troubled',
    USER_COUNTRY = 'user-country'
}

export type XsollaWidgetOptions = {
    access_token: string,
    sandbox?: boolean,
    lightbox?: {
        width?: string,
        height?: string,
        zIndex?: number,
        overlayOpacity?: number,
        overlayBackground?: string,
        modal?: boolean,
        closeByClick?: boolean,
        closeByKeyboard?: boolean,
        contentBackground?: string,
        contentMargin?: string,
        spinner?: 'xsolla' | 'round',
        spinnerColor?: string,
        childWindow?: {
            target: '_blank' | '_self' | '_parent'
        }
    }
}
